import createLoyaltyApiRequest from '~/src/api/requests/loyaltyRequest';
import { captureQueryError, TResponse } from '~/src/api/helper';

const ALREADY_REGISTERED = 2;
const PROGRAM_AVAILABLE = 1;
export interface IAvailiabilityData {
    available: -1 | 1 | 2;
    isAvailable: boolean,
    isRegistered: boolean,
}

export type TDataResponse = TResponse<IAvailiabilityData, any>;

interface IProps {
    domain: string,
    accessToken: string,
}

export const getAvailability = async({ domain, accessToken }: IProps): Promise<TDataResponse> => {
    const url = '/v1/program/availability';

    if (!domain || !accessToken) {
        return {
            isSuccess: false,
            error: `Неверные параметры domain: ${domain}, accessToken: ${accessToken}`,
        };
    }

    try {
        const response = await createLoyaltyApiRequest(domain, accessToken).get(url);
        const { available } = response.data;

        return {
            isSuccess: true,
            payload: {
                available,
                isAvailable: available === PROGRAM_AVAILABLE,
                isRegistered: available === ALREADY_REGISTERED,
            }
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
